import CircleIcon from '@mui/icons-material/Circle';
import BlockIcon from '@mui/icons-material/Block';

export const SIM_STATUSES = {
  active: 'Активна',
  store: 'На складе',
  blocked: 'Заблокирована',
};

export const SIM_STATUSES_OPTIONS = Object.entries(SIM_STATUSES).map(([value, label]) => ({
  name: value,
  value,
  label,
}));

export const SIM_STATUS_CONFIG = {
  active: {
    label: 'Активна',
    icon: <CircleIcon fontSize="small" className="text-green-500" />,
  },
  store: {
    label: 'На складе',
    icon: <CircleIcon fontSize="small" className="text-yellow-500" />,
  },
  blocked: {
    label: 'Заблокирована',
    icon: <BlockIcon fontSize="small" className="text-red-500" />,
  },
};
